// Mock data for the Special Events listing, used while the backend endpoint
// GET guest/special-events does not exist yet.
// Enable with REACT_APP_USE_MOCK_SPECIAL_EVENTS=true in .env.
// Shape mirrors the expected API response documented in
// src/services/client.js (getGuestSpecialEvents).
import moment from "moment";

const day = (offset) => moment().add(offset, "days").format("YYYY-MM-DD");

export const MOCK_SPECIAL_EVENTS = [
  {
    event_id: "ev-1001",
    medium_availability_id: 456,
    medium_id: 123,
    medium_name: "Test Gaurav S",
    languages: ["Bengali"],
    title: "testing",
    description:
      "A live professional demonstration of evidential mediumship. Join as an audience member — a few sitters will receive readings.",
    date: day(3),
    start_time: "04:30",
    end_time: "05:15",
    price: 1,
    currency: "USD",
    capacity: 4,
    booked_count: 0,
    session_id: 35,
    subsession_id: 101,
    // Each medium configures their own gateways — never assume every medium
    // supports the same set (see PLAN doc: real API keys this off the
    // medium's actual integrations, not a hardcoded default).
    payment_methods: {
      is_stripe_integrated: false,
      is_paypal_integrated: true,
      is_squareup_integrated: true,
    },
  },
  {
    event_id: "ev-1002",
    medium_availability_id: 457,
    medium_id: 124,
    medium_name: "Test NSVS-Central-Linda",
    languages: ["Czech"],
    title: "new public demo test",
    description: "testing public demo — open group demonstration, everyone welcome.",
    date: day(3),
    start_time: "16:15",
    end_time: "16:30",
    price: 0,
    currency: "USD",
    capacity: 6,
    booked_count: 0,
    session_id: 35,
    subsession_id: 101,
    payment_methods: {
      is_stripe_integrated: false,
      is_paypal_integrated: true,
      is_squareup_integrated: false,
    },
  },
  {
    event_id: "ev-1003",
    medium_availability_id: 456,
    medium_id: 123,
    medium_name: "Test Gaurav S",
    languages: ["Bengali"],
    title: "testing",
    description:
      "A live professional demonstration of evidential mediumship. Join as an audience member — a few sitters will receive readings.",
    date: day(4),
    start_time: "04:30",
    end_time: "05:15",
    price: 1,
    currency: "USD",
    capacity: 4,
    booked_count: 0,
    session_id: 35,
    subsession_id: 101,
    payment_methods: {
      is_stripe_integrated: false,
      is_paypal_integrated: true,
      is_squareup_integrated: true,
    },
  },
  {
    event_id: "ev-1004",
    medium_availability_id: 460,
    medium_id: 125,
    medium_name: "Maria Evergreen",
    languages: ["English", "Spanish"],
    title: "Evening of Spirit Connections",
    description:
      "Group demonstration focused on connecting audience members with loved ones in spirit. Bring an open mind and a question.",
    date: day(9),
    start_time: "19:00",
    end_time: "20:00",
    price: 15,
    currency: "USD",
    capacity: 20,
    booked_count: 7,
    session_id: 35,
    subsession_id: 101,
    // Stripe-only medium — must show the Stripe option and hide PayPal/Square.
    payment_methods: {
      is_stripe_integrated: true,
      is_paypal_integrated: false,
      is_squareup_integrated: false,
    },
  },
  {
    event_id: "ev-1005",
    medium_availability_id: 461,
    medium_id: 126,
    medium_name: "John Winter",
    languages: ["English"],
    title: "Sunday Morning Demonstration",
    description: "Relaxed Sunday morning group session with live audience readings.",
    date: day(12),
    start_time: "10:00",
    end_time: "11:00",
    price: 0,
    currency: "USD",
    capacity: 10,
    booked_count: 4,
    session_id: 35,
    subsession_id: 101,
    payment_methods: {
      is_stripe_integrated: false,
      is_paypal_integrated: false,
      is_squareup_integrated: true,
    },
  },
  {
    // Full event — must never appear in the list (capacity reached)
    event_id: "ev-1006",
    medium_availability_id: 462,
    medium_id: 125,
    medium_name: "Maria Evergreen",
    languages: ["English", "Spanish"],
    title: "Sold Out Showcase",
    description: "This one is full and should be hidden from the listing.",
    date: day(6),
    start_time: "18:00",
    end_time: "19:00",
    price: 10,
    currency: "USD",
    capacity: 5,
    booked_count: 5,
    session_id: 35,
    subsession_id: 101,
    payment_methods: {
      is_stripe_integrated: true,
      is_paypal_integrated: false,
      is_squareup_integrated: false,
    },
  },
];

// Mimics the axios response wrapper used by src/services/client.js so the
// listing page can treat mock and real responses identically.
export const getMockSpecialEvents = (params = {}) => {
  let events = MOCK_SPECIAL_EVENTS;
  if (params.medium_id) {
    events = events.filter(
      (event) => String(event.medium_id) === String(params.medium_id)
    );
  }
  if (params.availability_id) {
    events = events.filter(
      (event) =>
        String(event.medium_availability_id) === String(params.availability_id)
    );
  }
  return Promise.resolve({ data: { status: true, data: events } });
};
